import { Theme, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import {
  AiIcon,
  WbButton,
  WbButtonProps,
  ButtonAccessibilityProps,
} from '@agilelab/plugin-wb-platform';
import { useWittyAssistantEnabled } from '../../hooks/useWittyAssistantEnabled';

type AiGenerateActionButtonProps = Omit<WbButtonProps, 'startIcon' | 'label'> &
  ButtonAccessibilityProps;

const useStyles = makeStyles<Theme, { disabled: boolean }>(
  theme => ({
    aiButton: {
      color: theme.palette.accent.main,
      backgroundColor: theme.palette.white,
      border: 'solid 1px transparent',
      background: props =>
        props.disabled
          ? `linear-gradient( #ffffff, #ffffff) padding-box,linear-gradient(90deg, ${theme.palette.grey[200]}, ${theme.palette.grey[200]}) border-box`
          : 'linear-gradient( #ffffff, #ffffff) padding-box,linear-gradient(90deg, #EE72D3, #7C4DFF) border-box',
    },
    aiIcon: {
      color: props =>
        props.disabled ? theme.palette.grey[400] : theme.palette.accent.main,
    },
  }),
  { name: 'AiGenerateActionButton' },
);

export const AiGenerateActionButton = ({
  disabled = false,
  ...props
}: AiGenerateActionButtonProps) => {
  const { enabled, loading: loadingEnabled } = useWittyAssistantEnabled();
  const classes = useStyles({ disabled: disabled || !enabled });

  if (loadingEnabled || !enabled) {
    return null;
  }

  return (
    <WbButton
      disabled={disabled}
      variant="outlined" // can be overridden with props
      {...props}
      startIcon={<AiIcon className={classes.aiIcon} />}
      label="Generate"
      className={clsx(classes.aiButton, props.className)}
    />
  );
};
